/** PMSmart iconfont 项目配置（单一来源） */
export const ICONFONT_PROJECT_ID = 3466273;

/**
 * iconfont 项目管理页中的图标总数（广联达项目数据决策 / 项目 3466273）。
 * CDN 脚本未重新发布时可能少于该值；以 `npm run sync:icons` 后 `registry.json` 为准核对。
 */
export const ICONFONT_PROJECT_ICON_COUNT = 221;

/** Symbol 脚本 CDN；iconfont 重新生成后更新 hash 段并执行 npm run sync:icons */
export const ICONFONT_SCRIPT_URL =
  'https://at.alicdn.com/t/c/font_3466273_qt8gf89swes.js';

export const ICONFONT_SCRIPT_URL_PROTOCOL_RELATIVE = ICONFONT_SCRIPT_URL.replace(
  /^https?:/,
  ''
);

const _iconfontHash =
  ICONFONT_SCRIPT_URL.match(/font_3466273_([a-z0-9]+)\.js/)?.[1] ?? 'unknown';

/** preview/public 内已补丁的 Symbol 脚本（npm run sync:icons 生成；无 override 时与 CDN 一致） */
export const ICONFONT_SCRIPT_URL_PATCHED = `/iconfont/font_3466273_${_iconfontHash}.patched.js`;
